/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileUnknownSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileUnknownSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.667 13.208c0-.86-1.157-1.618-2.92-2.068-.06-2.253-1.287-3.349-3.747-3.349s-3.687 1.096-3.748 3.35c-1.761.45-2.919 1.207-2.919 2.067 0 .7.766 1.331 2 1.785L7.434 16.9l1.13.533.982-2.086c.84.191 1.8.315 2.828.35v2.511h1.25v-2.51a15.32 15.32 0 0 0 2.794-.343l1.01 2.274 1.142-.508-.94-2.115c1.255-.454 2.036-1.092 2.036-1.798Zm-8.632-3.633c-.284.267-.535.76-.535 1.742v.277a6.47 6.47 0 0 0 5 0v-.277c0-.982-.251-1.475-.535-1.742-.299-.28-.869-.534-1.965-.534s-1.666.253-1.965.534Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.748 11.14c1.762.45 2.919 1.208 2.919 2.068a.972.972 0 0 1-.033.248c-.198-.756-1.296-1.413-2.886-1.819-.06-2.253-1.288-3.349-3.748-3.349s-3.687 1.096-3.748 3.349c-1.59.406-2.687 1.063-2.886 1.82a.973.973 0 0 1-.032-.249c0-.86 1.157-1.618 2.918-2.068.06-2.253 1.288-3.349 3.748-3.349s3.688 1.096 3.748 3.35Zm-8.614 4.274-.7 1.486.192.09.706-1.5a7.67 7.67 0 0 1-.198-.076Zm10.253 1.789.184-.082-.75-1.69a7.896 7.896 0 0 1-.19.072l.756 1.7Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M10.505 11.596a6.473 6.473 0 0 0 4.99 0c.004.07.005.142.005.218v.277a6.472 6.472 0 0 1-5 0v-.277c0-.076.002-.148.005-.218Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileUnknownSmall
};
